import {createContext,useContext,type ReactNode} from 'react';

const Journey=createContext(false);
const Customer=createContext(false);
export const useWorkspaceJourney=()=>useContext(Journey);
export const useRadarCustomer=()=>useContext(Customer);

// The server-owned workspace flag is the only production entry into the rollout.
// Missing/false keeps both the legacy component tree and its CSS boundary intact.
export function RadarJourneyProvider({enabled,customer=false,children}:{enabled:boolean;customer?:boolean;children:ReactNode}) {
 return <Customer.Provider value={customer}><Journey.Provider value={enabled}>{enabled?<div className="radar-journey-enabled">{children}</div>:children}</Journey.Provider></Customer.Provider>;
}
